var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25205 9.97501L16.912 4.42301C18.612 3.61301 20.386 5.38801 19.577 7.08901L14.025 18.748C13.266 20.341 10.966 20.243 10.346 18.59L9.32005 15.851C9.21979 15.5838 9.06352 15.3412 8.86171 15.1393C8.65991 14.9375 8.41725 14.7813 8.15005 14.681L5.41005 13.654C3.75805 13.034 3.65905 10.734 5.25205 9.97501Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationArrow);
export default __webpack_public_path__ + "static/media/location-arrow.c1ca4f08f40dc73b2e803fd965e4be3a.svg";
export { ForwardRef as ReactComponent };